<template>
  <b-container>
    <b-row v-if="wallets.length">
      <b-col
        v-for="(wallet, index) in wallets"
        :key="index"
        md="4"
        class="mb-3"
      >
        <b-container
          class="bg-white shadow-sm rounded border border-light px-3"
        >
          <div class="d-flex justify-content-between align-items-center">
            <div class="font-weight-bold">{{ wallet.wallet_name }}</div>
            <switches
              :value="wallet.is_active"
              @input="confirmToggleStatus(wallet)"
              theme="custom"
              color="primary"
              text-enabled="On"
              text-disabled="Off"
              :type-bold="true"
              :emit-on-mount="false"
            />
          </div>
          <b-row class="mt-4 my-3">
            <b-col cols="3">
              <div
                class="wallet-icon"
                :style="`background-color: ${wallet.color}`"
              >
                <img
                  width="42"
                  height="42"
                  class="d-block mx-auto"
                  src="@/assets/images/icons/wallet.svg"
                  alt="Wallet"
                />
              </div>
            </b-col>
            <b-col cols="9">
              <div
                :class="
                  parseFloat(wallet.balance) > 0 ? 'text-black' : 'text-muted'
                "
              >
                <span class="font-weight-bold">&#8369;</span>
                <span class="ml-1 h5 font-weight-bolder">
                  {{ wallet.balance | currency }}
                </span>
              </div>
              <small class="text-muted font-weight-bolder">TOTAL BALANCE</small>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
    <div v-else class="d-flex justify-content-center align-items-center h4">
      No wallet found.
    </div>
    <b-modal
      ref="confirm-toggle-status-modal"
      hide-header
      centered
      no-close-on-backdrop
    >
      <template v-if="selectedWallet">
        <div class="h5 font-weight-bolder mt-3">
          {{ selectedWallet.is_active ? "Freeze" : "Activate" }} Wallet
        </div>
        <div>
          <i
            v-if="selectedWallet.is_active"
            class="bi bi-exclamation-triangle-fill text-warning mr-2"
            arial-hidden="true"
          ></i>
          Are you sure you want to
          {{ selectedWallet.is_active ? "freeze" : "activate" }} this wallet?
        </div>
      </template>
      <template slot="modal-footer">
        <b-container class="mt-2 w-100 d-flex justify-content-end">
          <b-button
            variant="outline-secondary"
            class="mr-3"
            @click="$refs['confirm-toggle-status-modal'].hide()"
          >
            Cancel
          </b-button>
          <b-button variant="primary" @click="toggleStatus" :disabled="loading">
            Yes
          </b-button>
        </b-container>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
import Switches from "vue-switches";
import commonMixins from "@/mixins/common";
import { mapState } from "vuex";

export default {
  data() {
    return {
      selectedWallet: null,
    };
  },
  mixins: [commonMixins],
  computed: {
    ...mapState("wallet", ["customerWallets", "loading"]),
    wallets() {
      this.customerWallets.forEach((wallet) => {
        wallet.is_active = !wallet.is_suspended;
      });

      return this.customerWallets;
    },
  },
  components: {
    Switches,
  },
  methods: {
    confirmToggleStatus(wallet) {
      this.selectedWallet = wallet;
      this.$refs["confirm-toggle-status-modal"].show();
    },
    async toggleStatus() {
      await this.$store.dispatch("wallet/suspendCustomerWallet", {
        customer_wallet_uuid: this.selectedWallet.customer_wallet_uuid,
        is_suspended: this.selectedWallet.is_active,
      });
      this.selectedWallet = null;
      this.$refs["confirm-toggle-status-modal"].hide();
    },
  },
};
</script>

<style lang="scss" scoped>
.wallet-icon {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>